import React from 'react';
import I18n from 'i18n-js';

import { RCButton } from '@reverbdotcom/cadence/components';
import { CheckCircleIcon } from '@phosphor-icons/react';

import { SellerListing } from './sellerListingsCollectionReducer';
import { usePublishListing } from './footer_buttons/usePublishListing';

export const COMPONENT_NAME = 'PublishListingPresentment';

interface IExternalProps {
  listing: SellerListing;
}

export default function PublishListingPresentment({ listing }: IExternalProps) {
  const { publish, isPublishing, canPublish } = usePublishListing({
    listing,
    componentName: COMPONENT_NAME,
  });

  return (
    <div className="seller-listing-insight-presentment">
      <RCButton
        variant="outlined"
        size="small"
        leadingIcon={<CheckCircleIcon />}
        onClick={publish}
        disabled={!canPublish || isPublishing}
        fullWidth
      >
        {I18n.t('discovery.listingsManagement.sellerListingCard.publish')}
      </RCButton>
    </div>
  );
}
